import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Instagram,
  Facebook,
  MessageCircle,
} from "lucide-react";

const contactInfo = [
  { icon: Phone, titleKey: "contact.info.phone", value: "(343) 777-8483", link: "tel:+13437778483" },
  { icon: Mail, titleKey: "contact.info.email", value: "info@djohomifoods.com", link: "mailto:info@djohomifoods.com" },
  { icon: MapPin, titleKey: "contact.info.address", value: "Ottawa, Ontario, Canada", link: null },
  { icon: Clock, titleKey: "contact.info.hours", value: "Mon - Sat: 10:00 AM - 8:00 PM", link: null },
];

const socialLinks = [
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Facebook, label: "Facebook", href: "#" },
];

const ContactInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="lg:col-span-1 space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-[#3D405B] mb-6 font-['Playfair_Display']">
          {t("contact.info.title")}
        </h2>
        <div className="space-y-6">
          {contactInfo.map((info) => (
            <div key={info.titleKey} className="flex items-start gap-4" data-testid={`contact-info-${info.titleKey}`}>
              <div className="w-12 h-12 bg-[#E07A5F]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <info.icon className="w-5 h-5 text-[#E07A5F]" />
              </div>
              <div>
                <h4 className="font-medium text-[#3D405B]">{t(info.titleKey)}</h4>
                {info.link ? (
                  <a href={info.link} className="text-[#6B705C] hover:text-[#E07A5F] transition-colors">{info.value}</a>
                ) : (
                  <p className="text-[#6B705C]">{info.value}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 className="font-semibold text-[#3D405B] mb-4">{t("contact.followUs")}</h3>
        <div className="flex gap-4">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.href}
              data-testid={`social-link-${social.label}`}
              className="w-12 h-12 bg-[#3D405B] hover:bg-[#E07A5F] rounded-xl flex items-center justify-center transition-colors"
            >
              <social.icon className="w-5 h-5 text-white" />
            </a>
          ))}
        </div>
      </div>

      <Card className="bg-[#2D6A4F] border-0">
        <CardContent className="p-6">
          <MessageCircle className="w-8 h-8 text-[#F2CC8F] mb-4" />
          <h3 className="text-white font-semibold text-lg mb-2">{t("contact.quickResponse.title")}</h3>
          <p className="text-white/80 text-sm">{t("contact.quickResponse.desc")}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactInfo;
